import { render, staticRenderFns } from "./IdetityManagerListPage.vue?vue&type=template&id=40605288"
import script from "./IdetityManagerListPage.vue?vue&type=script&lang=js"
export * from "./IdetityManagerListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports